import { render, staticRenderFns } from "./Ajout.vue?vue&type=template&id=a64eea5a&"
import script from "./Ajout.vue?vue&type=script&lang=js&"
export * from "./Ajout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports